module.exports = __webpack_public_path__ + "static/media/JarakSosialJikaBergejala.f432f300.jpg";